const REG_AWS_IMAGE_URL = /^(?:https?:)?(\/\/s3-us-west-1.amazonaws.com\/flamingos3\/.+?)(?:_(\d{0,4})x(\d{0,4}))?(?:\.(jpe?g|webp|png|svg|gif))?(\?.*)?$/i
const AWS_HOST = '//s3-us-west-1.amazonaws.com'

const parseAwsImageUrl = src => {
  const matched = REG_AWS_IMAGE_URL.exec(src)

  if (!matched) {
    return {
      matched: false
    }
  }

  const [
    originalSrc,
    srcPath,
    maxWidth,
    maxHeight,
    originalFileType,
    srcQuery
  ] = matched

  return {
    matched: true,
    originalSrc,
    srcPath,
    maxWidth,
    maxHeight,
    originalFileType,
    srcQuery
  }
}

// https://s3-us-west-1.amazonaws.com/flamingos3/20190326/images/6B314882A94F17049A9FEA7AA2A6B156_180x180.jpg
// https://s3-us-west-1.amazonaws.com/flamingos3/20190326/images/6B314882A94F17049A9FEA7AA2A6B156.jpg

const getImageSuffix = maxWidth => {
  if (maxWidth) {
    if (maxWidth <= 180) {
      return '_180x180'
    } else if (maxWidth <= 360) {
      return '_360x360'
    } else if (maxWidth >= 1080) {
      return ''
    } else {
      return '_720x720'
    }
  }

  return ''
}

const genAwsImageUrl = ({
  srcPath,
  originalFileType,
  srcQuery,
  maxWidth = 720
}) => {
  const imageSuffix = getImageSuffix(maxWidth)
  // not yet support webp at this time
  return `https:${srcPath}${imageSuffix}.${originalFileType}${srcQuery || ''}`
}


const isAwsImageUrl = src => src.indexOf(AWS_HOST) > -1

const adjustAwsImageUrl = (url, { maxWidth } = {}) => {
  const params = parseAwsImageUrl(url)
  if (!params.matched) {
    return url
  }

  return genAwsImageUrl({
    srcPath: params.srcPath,
    srcQuery: params.srcQuery,
    originalFileType: params.originalFileType,
    maxWidth: maxWidth
  })
}

export {
  isAwsImageUrl,
  adjustAwsImageUrl
}
